import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useToasts } from 'react-toast-notifications';
import Dropzone from 'react-dropzone';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import { pick, map, omit } from 'lodash';
import {
  Button, Form, FormGroup, Label, Input, Row, Col,
} from 'reactstrap';
import moment from 'moment';
import ReactImageFallback from 'react-image-fallback';
import {
  CreateContract, InviteArtistModal, DeleteOffer, PageLeaveAlert,
} from '../../../modals';
import {
  staticConstants, profileImageValidation, coverImageValidation, CAMPAIGN_TYPE, VIEW_TYPE, regexPattern, startDateValidation,
  endDateValidation, segmentInputDescValidation, selectValidation, FALLBACK_ICON, validationMessages,
  NUMERIC_VALUE, history, TARGET_AUDIENCE_RANGE, shareTypeValidation, PUBLIC_GIG_TYPE, BETA_POST_APPROVAL_TYPE,
  ARTIST_PARTICIPATION_TYPE,
} from '../../../../utils';
import CampaignTimeLine from './CampaignTimeLine';
import { Country } from '../../../shared/region';
import InputError from '../../../shared/elments/InputError';
import ImageCropper from '../../../modals/ImageCropper';
import CategoryTagSelect from '../../../comps/CategoryTagSelect';
import AgeCheckbox from './AgeCheckbox';
import { useScrollToError } from '../../../../hooks/useScrollToError';
import SeeOfferPreview from '../../../modals/SeeOfferPreview';

function CreateOffer(props) {
  // constants
  const IMG_UPLOAD_CLASS = 'image-uploaded';

  const { addToast } = useToasts();
  const {
    offerData, submitCallBack, categoryData, onDeleteOfferCallback, isEditOffer,
  } = props;
  const {
    register, handleSubmit, errors, setValue, clearError, setError, triggerValidation, unregister, formState,
  } = useForm({ mode: 'onBlur', nativeValidation: false });
  useScrollToError(errors);
  const { dirty } = formState;
  const [createContractModal, setCreateContractModal] = useState(false);
  const [isOpenCropModal, setIsOpenCropModal] = useState(false);
  const [image, setImage] = useState();
  const [clientLogo, setClientLogo] = useState();
  const [modalObj, setModalObj] = useState({});
  const [logoFileInputRandString, setLogoFileInputRandString] = useState(String(Math.random()));
  const [campaignTypeIdx, setCampaignTypeIdx] = useState(-1);
  const [viewTypeIdx, setViewTypeIdx] = useState(-1);
  const [publicGigTypeIdx, setPublicGigTypeIdx] = useState(-1);
  const [betaPostApprovalTypeIdx, setBetaPostApprovalTypeIdx] = useState(0);
  const [artistParticipationTypeIdx, setArtistParticipationTypeIdx] = useState(0);
  const [basePriceValue, setBasePriceValue] = useState();
  const [coverImage, setCoverImage] = useState();
  const [coverImageFileInputRandomeString, setCoverImageFileInputRandomeString] = useState(String(Math.random()));
  const [endDeadline, setEndDeadline] = useState(null);
  const [offerUrl, setOfferUrl] = useState(null);
  const [endDeadlineErrorMsg, setEndDeadlineErrorMsg] = useState('');
  const campaignTimeLineObj = {
    'startDate-0': null,
    'endDate-0': null,
    'shareType-0': [{
      'instagram-0': false,
      'facebook-0': false,
      'twitter-0': false,
      'youtube-0': false,
      'spotify-0': false,
    }],
    'campaignTitle-0': null,
    'description-0': null,
    'hashTag-0': null,
  };
  const [campaignTimeline, setCampaignTimeline] = useState([campaignTimeLineObj]);
  const [isMaleChecked, setisMaleChecked] = useState(false);
  const [isFemaleChecked, setisFemaleChecked] = useState(false);
  const [contractData, setContractInitialValue] = useState('');
  const [isCreateContractAdded, setCreateContractAdded] = useState(false);
  const [inviteArtistModal, setInviteArtistModal] = useState(false);
  const [isOfferPublished, setIsOfferPublished] = useState(false);
  const [filledOfferObj, setFilledOfferObj] = useState({});
  const [isGenderAudienceError, setIsGenderAudienceError] = useState(false);
  const [isDeleteOfferModal, setDeleteOfferModal] = useState(false);
  const [isPageLeaveModal, setPageLeaveModal] = useState(false);
  const [isAgeRangeError, setIsAgeRangeError] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [isPinToTop, setIsPinToTop] = useState(false);
  const [isClientLogoHide, setIsClientLogoHide] = useState(false);
  const [isSeeOfferPreviewModal, setIsSeeOfferPreviewModal] = useState(false);

  const [form, setForm] = useState({
    country: [],
    categories: null,
    campaignType: '',
    viewType: '',
    campaignTimeline,
    gigType: '',
    isBetaPostApproval: false,
    isArtistParticipation: false,
  });

  const toggleCreateContractModal = () => {
    setCreateContractModal(!createContractModal);
  };

  const toggleInviteArtistModal = () => {
    setInviteArtistModal(!inviteArtistModal);
  };

  const toggleDeleteOfferModal = () => {
    setDeleteOfferModal(!isDeleteOfferModal);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.add('bg-grey');
    register({ name: 'campaignType' }, { required: true });
    register({ name: 'viewType' }, { required: true });
    selectValidation(register, 'categories');
    selectValidation(register, 'country');
    profileImageValidation(register, 'clientLogoUpload');
    coverImageValidation(register, 'coverImageUpload');
    if (offerData) {
      const currentOfferData = offerData;
      const targetAudienceData = offerData.targetAudience;
      const campaignTimeLineData = [];

      const updateArrValue = (arrayData) => {
        const updatedData = [];
        map(arrayData, (ele) => {
          if (ele) {
            delete ele.__typename;
            updatedData.push(ele);
          }
        });
        return updatedData;
      };
      targetAudienceData.audienceAge && delete targetAudienceData.audienceAge.__typename;

      map(offerData.campaignTimeline, (item, index) => {
        if (item) {
          const dateInterval = moment(item.startDate).diff(moment(), 'minutes');
          campaignTimeLineData.push({
            _id: item._id,
            [`startDate-${index}`]: !offerData.isPublish && dateInterval < 0 ? null : new Date(item.startDate),
            [`endDate-${index}`]: !offerData.isPublish && dateInterval < 0 ? null : new Date(item.endDate),
            [`shareType-${index}`]: [{
              [`instagram-${index}`]: item.shareType.instagram,
              [`facebook-${index}`]: item.shareType.facebook,
              [`twitter-${index}`]: item.shareType.twitter,
              [`youtube-${index}`]: item.shareType.youtube,
              [`spotify-${index}`]: item.shareType.spotify,
            }],
            [`campaignTitle-${index}`]: item.campaignTitle,
            [`description-${index}`]: item.description,
            [`hashTag-${index}`]: item.hashTag,
          });
        }
      });

      const preFilledData = {
        country: updateArrValue(targetAudienceData.country),
        categories: updateArrValue(currentOfferData.categories),
        campaignType: currentOfferData.campaignType,
        viewType: currentOfferData.viewType,
        gigType: currentOfferData.gigType,
        isBetaPostApproval: currentOfferData.isBetaPostApproval,
        isArtistParticipation: currentOfferData.isArtistParticipation,
      };
      setValue([
        { title: currentOfferData.title },
        { clientName: currentOfferData.clientName },
        { basePrice: currentOfferData.basePrice },
        { description: currentOfferData.description },
        { offerUrl: currentOfferData.offerUrl },
        { categories: updateArrValue(currentOfferData.categories) },
        { country: updateArrValue(targetAudienceData.country) },
        { campaignTimeline: campaignTimeLineData },
        { basePriceText: currentOfferData.basePriceText },
      ]);

      setClientLogo(currentOfferData.clientLogo || FALLBACK_ICON);
      setCampaignTimeline(campaignTimeLineData);
      setViewTypeIdx(VIEW_TYPE.findIndex((i) => i.value === currentOfferData.viewType));
      setValue('viewType', currentOfferData.viewType);
      setValue('campaignType', currentOfferData.campaignType);
      setPublicGigTypeIdx(PUBLIC_GIG_TYPE.findIndex((i) => i.value === currentOfferData.gigType));
      setValue('gigType', currentOfferData.gigType);
      setBetaPostApprovalTypeIdx(BETA_POST_APPROVAL_TYPE.findIndex((i) => i.value === currentOfferData.isBetaPostApproval));
      setValue('isBetaPostApproval', currentOfferData.isBetaPostApproval);
      setArtistParticipationTypeIdx(ARTIST_PARTICIPATION_TYPE.findIndex((i) => i.value === currentOfferData.isArtistParticipation));
      setValue('isArtistParticipation', currentOfferData.isArtistParticipation);
      setCampaignTypeIdx(CAMPAIGN_TYPE.findIndex((i) => i.value === currentOfferData.campaignType));
      setisMaleChecked(targetAudienceData.gender.includes('male'));
      setisFemaleChecked(targetAudienceData.gender.includes('female'));
      setContractInitialValue(offerData.createContract);
      setCreateContractAdded(!!offerData.createContract.length);
      setIsOfferPublished(offerData.isPublish);
      setCheckedItems(targetAudienceData.audienceAge);
      clearError(['campaignType', 'viewType', 'categories', 'country', 'male', 'gigType', 'isArtistParticipation', 'isBetaPostApproval']);
      setCoverImage(currentOfferData.coverImage);
      setEndDeadline(new Date(currentOfferData.endDeadline));
      setOfferUrl(currentOfferData.offerUrl);
      setIsPinToTop(currentOfferData.isPinToTop); // Need to set valid key incase of edit
      setIsClientLogoHide(currentOfferData.isClientLogoHide); // Need to set valid key incase of edit
      setForm({
        ...form,
        ...preFilledData,
        campaignTimeline: campaignTimeLineData,
      });
    }
  }, [offerData]);

  useEffect(() => {
    if (campaignTimeline.length) {
      map(campaignTimeline, (item, index) => {
        startDateValidation(register, `startDate-${index}`, item[`startDate-${index}`]);
        endDateValidation(register, `endDate-${index}`, item[`endDate-${index}`]);
        segmentInputDescValidation(register, `description-${index}`, item[`description-${index}`]);
        shareTypeValidation(register, `shareType-${index}`, item[`shareType-${index}`], true);
        segmentInputDescValidation(register, `hashTag-${index}`, item[`hashTag-${index}`]);
      });

      if (isOfferPublished) {
        map(campaignTimeline, (item, index) => {
          setValue(`startDate-${index}`, new Date(item.startDate));
          setValue(`endDate-${index}`, new Date(item.endDate));
          setValue(`description-${index}`, item.description);
          setValue(`hashTag-${index}`, item.hashTag);
          setValue(`campaignTitle-${index}`, item.campaignTitle);
          setValue(`facebook-${index}`, item[`shareType-${index}`][0][`facebook-${index}`]);
          setValue(`instagram-${index}`, item[`shareType-${index}`][0][`instagram-${index}`]);
          setValue(`twitter-${index}`, item[`shareType-${index}`][0][`twitter-${index}`]);
          setValue(`youtube-${index}`, item[`shareType-${index}`][0][`youtube-${index}`]);
          setValue(`spotify-${index}`, item[`shareType-${index}`][0][`spotify-${index}`]);
          clearError([`startDate-${index}`, `endDate-${index}`, `description-${index}`]);
          triggerValidation([`startDate-${index}`, `endDate-${index}`, `description-${index}`]);
        });
      }
    }
  }, [campaignTimeline]);

  const handleCountryChange = (selectedOption) => {
    clearError('country');
    setValue('country', selectedOption);
    setForm({
      ...form,
      country: selectedOption,
    });
  };

  const handleSelectedCategories = (selectedOption) => {
    selectedOption && selectedOption.length && clearError('categories');
    setValue('categories', selectedOption);
    setForm({
      ...form,
      categories: selectedOption,
    });
  };

  const handleLogoSubmit = async (e, fieldName) => {
    const clientLogoUpload = e[0];
    setValue(fieldName, e[0]);
    const success = await triggerValidation(fieldName);
    if (success) {
      setImage(clientLogoUpload);
      setIsOpenCropModal(true);
      setModalObj({
        width: 500,
        height: 500,
        isClientLogo: true,
        callback: (img) => setClientLogo(img),
      });
    }
  };

  const hideFileSelectModal = () => {
    setIsOpenCropModal(false);
    setLogoFileInputRandString(String(Math.random()));
    setCoverImageFileInputRandomeString(String(Math.random()));
  };

  const onSubmitContract = (content) => {
    setContractInitialValue(content);
    setCreateContractAdded(true);
  };

  const removeIndexFromArr = (reqArr) => {
    const { length } = reqArr;
    const upatedArr = [];
    for (let i = 0; i < length; i += 1) {
      const obj = reqArr[i];
      const updatedObj = {};
      Object.keys(obj).forEach((key) => {
        const updateKey = key.split('-')[0];
        updatedObj[updateKey] = obj[key];
        if (updateKey === 'shareType') {
          const socialType = removeIndexFromArr(updatedObj.shareType);
          updatedObj.shareType = socialType;
        }
      });
      upatedArr.push(updatedObj);
    }
    return upatedArr;
  };

  const validateCoverImage = () => {
    if (!coverImage) {
      setError('coverImageUpload', 'required');
      return false;
    }
    return true;
  };

  const validateAgeRangeSelection = () => {
    if (!Object.values(checkedItems).some((val) => val === true)) {
      setIsAgeRangeError(true);
      return false;
    }
    return true;
  };

  const validateGenderSelection = () => {
    if (!isMaleChecked && !isFemaleChecked) {
      setIsGenderAudienceError(true);
      return false;
    }
    return true;
  };

  const validateClientLogoSelection = () => {
    if (!isClientLogoHide && !clientLogo) {
      setError('clientLogoUpload', 'required');
      return false;
    }
    return true;
  };

  const validateDeadline = () => {
    if (!endDeadline) {
      setError('endDeadline', 'required');
      return false;
    }
    return true;
  };

  const validateBasePrice = (data) => {
    if (data.basePriceText.length >= NUMERIC_VALUE.MAX_BASE_PRICE_INPUT_LIMIT) {
      setError('basePriceText', 'maxLength');
      return false;
    }
    if (!data.basePrice && !data.basePriceText) {
      setError('basePrice', 'required');
      return false;
    }
    return true;
  };

  const validateRequestParticipationDate = (maxOfferDate) => {
    if (!moment(endDeadline).isSameOrBefore(moment(maxOfferDate))) {
      setError('endDeadline', 'message');
      setEndDeadlineErrorMsg(validationMessages.LESS_THAN_MAX_DATE);
      return false;
    }
    return true;
  };

  const validateCustomFields = (data) => {
    const validationResult = [];
    validationResult.push(validateGenderSelection());
    validationResult.push(validateAgeRangeSelection());
    validationResult.push(validateClientLogoSelection());
    validationResult.push(validateDeadline());
    if (offerUrl) {
      validationResult.push(validateBasePrice(data));
    }
    validationResult.push(validateBasePrice(data));
    validationResult.push(validateCoverImage());
    return !validationResult.some((val) => val === false);
  };

  const formValidate = (data, isPublish, callback) => {
    if (!validateCustomFields(data)) {
      return;
    }
    if (isPublish && !isCreateContractAdded) {
      addToast('You need to save a contract to publish an opportunity.', { appearance: 'error' });
    } else {
      const createOfferObj = pick(data, ['title', 'clientName', 'campaignType', 'viewType',
        'description', 'offerUrl', 'categories', 'gigType', 'isArtistParticipation', 'isBetaPostApproval']);
      createOfferObj.campaignTimeline = removeIndexFromArr(campaignTimeline);
      const genderAudience = [];
      isMaleChecked && genderAudience.push('male');
      isFemaleChecked && genderAudience.push('female');
      createOfferObj.targetAudience = {
        audienceAge: checkedItems,
        country: data.country,
        gender: genderAudience,
      };
      createOfferObj.categories = map(data.categories, (ele) => omit(ele, ['_id', 'name', 'subCategoryId', '__typename']));
      createOfferObj.basePrice = Number(data.basePrice);
      createOfferObj.basePriceText = data.basePriceText;
      createOfferObj.createContract = contractData;
      createOfferObj.clientLogo = clientLogo || null;
      createOfferObj.isPublish = isPublish;
      createOfferObj.isPinToTop = isPinToTop;
      createOfferObj.isClientLogoHide = isClientLogoHide;
      createOfferObj.gigType = form.gigType;
      createOfferObj.isBetaPostApproval = form.isBetaPostApproval;
      createOfferObj.isArtistParticipation = form.isArtistParticipation;
      createOfferObj.endDeadline = moment(endDeadline).endOf('day').toDate();
      createOfferObj.coverImage = coverImage;
      createOfferObj.offerMinDate = new Date(Math.min.apply(null, createOfferObj.campaignTimeline.map((e) => new Date(e.startDate))));
      const endDateOfOffer = new Date(Math.max.apply(null, createOfferObj.campaignTimeline.map((e) => new Date(e.endDate).getTime())));
      createOfferObj.offerMaxDate = moment(endDateOfOffer).endOf('day').toDate();
      if (!validateRequestParticipationDate(createOfferObj.offerMaxDate)) {
        return;
      }
      setBasePriceValue(createOfferObj.basePrice);
      if (isEditOffer) {
        createOfferObj.offerId = offerData._id;
      }
      setFilledOfferObj(createOfferObj);
      callback(createOfferObj);
    }
  };

  const onSubmit = (data) => {
    formValidate(data, false, (offereObj) => {
      submitCallBack(offereObj);
    });
  };

  const handlePublishOffer = (data) => {
    formValidate(data, true, (offereObj) => {
      if (isCreateContractAdded) {
        if (!isOfferPublished && offereObj.viewType === 'private') {
          toggleInviteArtistModal();
        } else {
          submitCallBack(offereObj);
        }
      }
    });
  };

  const publishAndInviteOffer = (inviteArtistData) => {
    const offerObj = { ...filledOfferObj, ...inviteArtistData };
    submitCallBack(offerObj);
  };

  const toggleCampaignType = (defaultValue, selectedIndex) => {
    if (campaignTypeIdx === selectedIndex) {
      setCampaignTypeIdx(-1);
      setValue('campaignType', '');
      setForm({
        ...form,
        campaignType: '',
      });
    } else {
      setCampaignTypeIdx(selectedIndex);
      clearError('campaignType');
      setValue('campaignType', defaultValue);
      setForm({
        ...form,
        campaignType: defaultValue,
      });
    }
  };

  const renderCampaignType = () => {
    const campaignType = CAMPAIGN_TYPE;
    return map(campaignType, (item, index) => item && (
      <div
        className="select-label-wrap"
        key={`campaign-${item.value}`}
        onClick={() => { toggleCampaignType(item.value, index); }}
      >
        <label className="button-checkbox" htmlFor={`campaign${index + 1}`}>
          <input
            key={index}
            type="checkbox"
            checked={item.index === (campaignTypeIdx + 1) || false}
            defaultValue={item.index === (campaignTypeIdx + 1) || false}
          />
          <span>{item.label}</span>
        </label>
      </div>
    ));
  };

  const setPublcGigTypeValue = (index, value) => {
    setPublicGigTypeIdx(index);
    setValue('gigType', value);
    clearError('gigType');
    setForm({
      ...form,
      gigType: value,
    });
  };

  const toggleOfferType = (defaultValue, selectedIndex, type) => {
    if (type === 'betaPost') {
      setBetaPostApprovalTypeIdx(selectedIndex);
      clearError('isBetaPostApproval');
      setValue('isBetaPostApproval', defaultValue);
      setForm({
        ...form,
        isBetaPostApproval: defaultValue,
      });
    } else {
      setArtistParticipationTypeIdx(selectedIndex);
      clearError('isArtistParticipation');
      setValue('isArtistParticipation', defaultValue);
      setForm({
        ...form,
        isArtistParticipation: defaultValue,
      });
    }
  };

  const toggleViewType = (defaultValue, selectedIndex) => {
    if (viewTypeIdx === selectedIndex) {
      if (defaultValue === staticConstants.STATUS_TYPE.PUBLIC) {
        setPublcGigTypeValue(-1, '');
      }
      setViewTypeIdx(-1);
      setValue('viewType', '');
      setForm({
        ...form,
        viewType: '',
      });
    } else {
      setViewTypeIdx(selectedIndex);
      clearError('viewType');
      setValue('viewType', defaultValue);
      setForm({
        ...form,
        viewType: defaultValue,
      });
      if (defaultValue !== staticConstants.STATUS_TYPE.PUBLIC) {
        setPublcGigTypeValue(-1, '');
        setIsPinToTop(false);
      }
      if (defaultValue === staticConstants.STATUS_TYPE.PUBLIC) {
        setPublcGigTypeValue(0, 'standard');
      }
    }
  };

  const togglePublicGigType = (defaultValue, selectedIndex) => {
    if (publicGigTypeIdx === selectedIndex) {
      setPublcGigTypeValue(-1, '');
    } else {
      setPublicGigTypeIdx(selectedIndex);
      clearError('gigType');
      setValue('gigType', defaultValue);
      setForm({
        ...form,
        gigType: defaultValue,
      });
    }
  };

  const renderViewType = () => {
    const viewType = VIEW_TYPE;
    return map(viewType, (item, index) => item && (
      <div
        className="select-label-wrap"
        key={`viewType-${item.value}`}
        onClick={() => { toggleViewType(item.value, index); }}
      >
        <label className="button-checkbox" htmlFor={`viewType${index + 1}`}>
          <input
            key={index}
            type="checkbox"
            checked={item.index === (viewTypeIdx + 1) || false}
            defaultValue={item.index === (viewTypeIdx + 1) || false}
          />
          <span>{item.label}</span>
        </label>
      </div>
    ));
  };

  const renderPublicGigType = () => {
    const gigType = PUBLIC_GIG_TYPE;
    return map(gigType, (item, index) => item && (
      <div
        className="select-label-wrap"
        key={`gigType-${item.value}`}
        onClick={() => { togglePublicGigType(item.value, index); }}
      >
        <label className="button-checkbox" htmlFor={`gigType${index + 1}`}>
          <input
            key={index}
            type="checkbox"
            checked={item.index === (publicGigTypeIdx + 1) || false}
            defaultValue={item.index === (publicGigTypeIdx + 1) || false}
          />
          <span>{item.label}</span>
        </label>
      </div>
    ));
  };

  const renderBetaPostApproval = () => {
    const betaPostApprovalType = BETA_POST_APPROVAL_TYPE;
    return map(betaPostApprovalType, (item, index) => item && (
      <div
        className="checkbox-with-text small"
        key={`isBetaPostApproval-${item.value}`}
        onClick={() => { toggleOfferType(item.value, index, 'betaPost'); }}
      >
        <label htmlFor={`isBetaPostApproval${index + 1}`} className="input-container-green m-0">
          <input
            key={index}
            type="checkbox"
            checked={item.index === (betaPostApprovalTypeIdx + 1) || false}
            defaultValue={item.index === (betaPostApprovalTypeIdx + 1) || false}
          />
          <span className="checkmark" />
          <span className="checkbox-text">{item.label}</span>
        </label>
      </div>
    ));
  };

  const renderArtistParticipation = () => {
    const artistParticipationType = ARTIST_PARTICIPATION_TYPE;
    return map(artistParticipationType, (item, index) => item && (
      <div
        className="checkbox-with-text small"
        key={`isArtistParticipation-${item.value}`}
        onClick={() => { toggleOfferType(item.value, index); }}
      >
        <label htmlFor={`isArtistParticipation${index + 1}`} className="input-container-green m-0">
          <input
            key={index}
            type="checkbox"
            checked={item.index === (artistParticipationTypeIdx + 1) || false}
            defaultValue={item.index === (artistParticipationTypeIdx + 1) || false}
          />
          <span className="checkmark" />
          <span className="checkbox-text">{item.label}</span>
        </label>
      </div>
    ));
  };

  const setAudienceGenderType = (event) => {
    if (event.target.name === 'male') {
      setisMaleChecked(event.target.checked);
      setIsGenderAudienceError(false);
      clearError('male');
    } else {
      setisFemaleChecked(event.target.checked);
      setIsGenderAudienceError(false);
      clearError('male');
    }
  };

  function handleChangeTitle(event, i) {
    const values = [...campaignTimeline];
    values[i][`campaignTitle-${i}`] = event.target.value.trimLeft();
    setCampaignTimeline(values);
    setForm({
      ...form,
      campaignTimeline: values,
    });
  }

  const handleChangeHashtag = (event, i) => {
    const values = [...campaignTimeline];
    values[i][`hashTag-${i}`] = event.target.value.trimLeft();
    setCampaignTimeline(values);
    setForm({
      ...form,
      campaignTimeline: values,
    });
  };

  const handleAddAnother = () => {
    const values = [...campaignTimeline];
    const campaignTimelineLength = values.length;
    values.push({
      [`startDate-${campaignTimelineLength}`]: null,
      [`endDate-${campaignTimelineLength}`]: null,
      [`shareType-${campaignTimelineLength}`]: [{
        [`instagram-${campaignTimelineLength}`]: false,
        [`facebook-${campaignTimelineLength}`]: false,
        [`twitter-${campaignTimelineLength}`]: false,
        [`youtube-${campaignTimelineLength}`]: false,
        [`spotify-${campaignTimelineLength}`]: false,
      }],
      [`campaignTitle-${campaignTimelineLength}`]: null,
      [`description-${campaignTimelineLength}`]: null,
      [`hashTag-${campaignTimelineLength}`]: null,
    });
    setCampaignTimeline(values);
  };

  const reIntializeTimeLineList = (listArr, shareIndex) => {
    const { length } = listArr;
    const upatedArr = [];
    for (let i = 0; i < length; i += 1) {
      const obj = listArr[i];
      const updatedObj = {};
      Object.keys(obj).forEach((key) => {
        const splitValue = key.split('-')[0];
        const updateKey = splitValue.replace(splitValue, (shareIndex ? `${splitValue}-${shareIndex}` : `${splitValue}-${i}`));
        updatedObj[updateKey] = obj[key];
        if (updateKey === `shareType-${i}`) {
          const socialType = reIntializeTimeLineList(updatedObj[`shareType-${i}`], i);
          updatedObj[`shareType-${i}`] = socialType;
        }
      });
      upatedArr.push(updatedObj);
    }
    return upatedArr;
  };

  const handleRemove = (i) => {
    const values = [...campaignTimeline];
    clearError(`startDate-${i}`);
    clearError(`endDate-${i}`);
    clearError(`description-${i}`);
    clearError(`hashTag-${i}`);
    clearError(`shareType-${i}`);
    unregister(`startDate-${i}`);
    unregister(`endDate-${i}`);
    unregister(`description-${i}`);
    unregister(`hashTag-${i}`);
    unregister(`shareType-${i}`);
    triggerValidation([`startDate-${i}`, `endDate-${i}`, `description-${i}`, `hashTag-${i}`, `shareType-${i}`]);
    values.splice(i, 1);
    const updatedValues = reIntializeTimeLineList(values);
    setCampaignTimeline(updatedValues);
  };

  const handleEditorChange = (content, index) => {
    const values = [...campaignTimeline];
    values[index][`description-${index}`] = content;
    clearError(`description-${index}`);
    setValue(`description-${index}`, content);
    setCampaignTimeline(values);
    setForm({
      ...form,
      campaignTimeline: values,
    });
  };

  const handleFromDate = (date, key, index) => {
    const values = [...campaignTimeline];
    if (key === 'startDate') {
      values[index][`startDate-${index}`] = date;
      const endDateValue = values[index][`endDate-${index}`];
      const isErr = endDateValue && (moment(endDateValue).diff(moment(date), 'days') < 0);
      if (isErr) {
        setError(`startDate-${index}`, 'invalid');
        values[index][`startDate-${index}`] = null;
      } else {
        clearError(`startDate-${index}`);
        setValue(`startDate-${index}`, date);
        setCampaignTimeline(values);
      }
    } else {
      values[index][`endDate-${index}`] = date;
      const startDateValue = values[index][`startDate-${index}`];
      const isErr = startDateValue && (moment(startDateValue).diff(moment(date), 'days') > 0);
      if (isErr) {
        setError(`endDate-${index}`, 'invalid');
        values[index][`endDate-${index}`] = null;
      } else {
        clearError(`endDate-${index}`);
        setValue(`endDate-${index}`, date);
        setCampaignTimeline(values);
      }
    }
  };

  const handleShareTimeLine = (event, index) => {
    const values = [...campaignTimeline];
    const elementValue = values[index][`shareType-${index}`][0];
    clearError(`shareType-${index}`);
    switch (event.target.name) {
      case `${staticConstants.SOCIAL_SHARE_TYPE.FACEBOOK}-${index}`:
        elementValue[`facebook-${index}`] = event.target.checked;
        setCampaignTimeline(values);
        break;
      case `${staticConstants.SOCIAL_SHARE_TYPE.INSTAGRAM}-${index}`:
        elementValue[`instagram-${index}`] = event.target.checked;
        setCampaignTimeline(values);
        break;
      case `${staticConstants.SOCIAL_SHARE_TYPE.TWITTER}-${index}`:
        elementValue[`twitter-${index}`] = event.target.checked;
        setCampaignTimeline(values);
        break;
      case `${staticConstants.SOCIAL_SHARE_TYPE.YOUTUBE}-${index}`:
        elementValue[`youtube-${index}`] = event.target.checked;
        setCampaignTimeline(values);
        break;
      case `${staticConstants.SOCIAL_SHARE_TYPE.SPOTIFY}-${index}`:
        elementValue[`spotify-${index}`] = event.target.checked;
        setCampaignTimeline(values);
        break;
      default:
        break;
    }
  };

  const handleBackButton = () => {
    if (dirty) {
      setPageLeaveModal(!isPageLeaveModal);
    } else {
      document.body.classList.remove('bg-grey');
      history.goBack();
    }
  };

  const handleAgeRangeChange = (event) => {
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked,
    });
    setIsAgeRangeError(false);
  };

  const handleImageSubmit = async (e, fieldName) => {
    const coverImageFile = e[0];
    setValue(fieldName, e[0]);
    const success = await triggerValidation(fieldName);
    if (success) {
      setImage(coverImageFile);
      setIsOpenCropModal(true);
      setModalObj({
        width: 1000,
        height: 232,
        callback: (img) => setCoverImage(img),
      });
    }
  };

  const handleOfferTimeline = (date, key) => {
    if (key === 'endDeadline') {
      setEndDeadline(date);
      clearError('endDeadline');
    }
  };

  const handleBasePriceValueFieldsFocus = (e) => {
    switch (e.target.name) {
      case 'basePrice':
        setValue('basePriceText', '');
        break;
      case 'basePriceText':
        setBasePriceValue(0);
        setValue('basePrice', 0);
        break;
      default:
        break;
    }
  };

  const handleOfferUrl = (value) => {
    setOfferUrl(value);
    clearError('offerUrl');
  };

  return (
    <>
      <Form className="create-offer" onSubmit={handleSubmit(onSubmit)}>
        <div className="create-offer-head">
          <div className="create-offer-head-container">
            <div onClick={() => handleBackButton()} className="create-offer-head-back-btn cursor-pointer">
              <span className="icon icon-next rotate-180" />
              Back
            </div>
            <div className="create-offer-head-btn-group">
              {
                isEditOffer
                && (
                  <span
                    className="btn btn-delete"
                    onClick={() => { toggleDeleteOfferModal(); }}
                  >
                    Delete opportunity
                  </span>
                )
              }
              {!isOfferPublished
                && (
                  <Button
                    type="submit"
                    color="save"
                    className="btn-md"
                  >
                    Save for now
                  </Button>
                )}

              <Button
                type="button"
                color="contract"
                className="btn-md"
                onClick={toggleCreateContractModal}
              >
                {isCreateContractAdded ? 'Edit contract' : 'Add contract'}
              </Button>
              {
                isCreateContractAdded
                && (
                  <Button
                    type="button"
                    color="publish"
                    className="btn-md"
                    onClick={handleSubmit(handlePublishOffer)}
                  >
                    Publish opportunity
                  </Button>
                )
              }
            </div>
          </div>
        </div>
        <div className="create-offer-content">
          <div className="create-offer-content-container">
            <div className="create-offer-detail">
              <h2>
                <span>
                  {isEditOffer ? 'Edit opportunity details' : 'Add opportunity details'}
                </span>
                <button type="button" disabled={!coverImage} className="btn btn-save" onClick={() => setIsSeeOfferPreviewModal(!isSeeOfferPreviewModal)}>See Preview</button>
              </h2>
              <div className="create-offer-detail-wrapper">
                <FormGroup className={`upload-wrapper w-100 ${errors.clientLogoUpload ? 'image-error' : ''}`}>
                  <Label
                    for="Description"
                  >
                    Cover image
                  </Label>
                  <Dropzone onDrop={(acceptedFiles) => handleImageSubmit(acceptedFiles, 'coverImageUpload')}>
                    {({ getRootProps, getInputProps }) => (
                      <div className={`upload-wrapper ${coverImage ? IMG_UPLOAD_CLASS : ''}`} {...getRootProps()}>
                        <input {...getInputProps()} key={coverImageFileInputRandomeString} multiple={false} accept="image/*" />
                        <Label className={`image-upload-button lg m-0 ${coverImage ? IMG_UPLOAD_CLASS : ''}`}>
                          {
                            coverImage ? (
                              <>
                                <ReactImageFallback
                                  src={coverImage}
                                  fallbackImage={FALLBACK_ICON}
                                  className="img-cover"
                                  alt="profile"
                                />
                                <span className="icon icon-camera" />
                              </>
                            )
                              : (
                                <>
                                  <span>
                                    Upload
                                    <em>Recommended size 1440px/624px</em>
                                  </span>
                                </>
                              )
                          }
                        </Label>
                      </div>
                    )}
                  </Dropzone>
                  <InputError error={errors.coverImageUpload} />
                </FormGroup>
                <FormGroup className={`upload-wrapper upload-wrapper-custom w-100 ${errors.clientLogoUpload ? 'image-error' : ''}`}>
                  <div className="dropzone-container">
                    <Label
                      for="Description"
                    >
                      {' Client\'s logo'}
                    </Label>
                    <Dropzone onDrop={(acceptedFiles) => handleLogoSubmit(acceptedFiles, 'clientLogoUpload')}>
                      {({ getRootProps, getInputProps }) => (
                        <div className={`upload-wrapper image-small-upload-wrapper ${clientLogo ? IMG_UPLOAD_CLASS : ''}`} {...getRootProps()}>
                          <input {...getInputProps()} key={logoFileInputRandString} multiple={false} accept="image/*" />
                          <Label className={`image-small-upload-button m-0 ${clientLogo ? IMG_UPLOAD_CLASS : ''}`}>
                            {
                              clientLogo ? (
                                <>
                                  <ReactImageFallback
                                    src={clientLogo}
                                    fallbackImage={FALLBACK_ICON}
                                    className="img-cover"
                                    alt="profile"
                                  />
                                  <span className="icon icon-camera" />
                                </>
                              )
                                : (
                                  <>
                                    <p />
                                  </>
                                )
                            }
                          </Label>
                        </div>
                      )}
                    </Dropzone>
                    {!clientLogo && (
                      <h4 className="upload-logo-text">
                        Upload logo
                        <em>Recommended size 500px/500px</em>
                      </h4>
                    )}
                    <InputError error={errors.clientLogoUpload} />
                  </div>
                  <div className="checkbox-with-text">
                    <label htmlFor="offerLogo" className="input-container-green">
                      <input
                        name="offerLogo"
                        id="offerLogo"
                        type="checkbox"
                        checked={isClientLogoHide}
                        onClick={(e) => setIsClientLogoHide(e.target.checked)}
                      />
                      <span className="checkmark" />
                      <span className="checkbox-text">Do not show logo</span>
                    </label>
                  </div>
                </FormGroup>
                <FormGroup className={errors.clientName ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
                  <Label
                    for="clientName"
                  >
                    Client name
                  </Label>
                  <Input
                    type="text"
                    name="clientName"
                    placeholder="Enter client Name"
                    onChange={(e) => { e.target.value = e.target.value.trimLeft(); }}
                    innerRef={register({ required: true, maxLength: NUMERIC_VALUE.TWO_HUNDRED, minLength: NUMERIC_VALUE.THREE })}
                  />
                  <InputError error={errors.clientName} max={NUMERIC_VALUE.TWO_HUNDRED} min={NUMERIC_VALUE.THREE} />
                </FormGroup>
                <FormGroup className={errors.title ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
                  <Label
                    for="title"
                  >
                    Opportunity title
                  </Label>
                  <Input
                    type="text"
                    name="title"
                    placeholder="Enter opportunity title"
                    onChange={(e) => { e.target.value = e.target.value.trimLeft(); }}
                    innerRef={register({ required: true, maxLength: NUMERIC_VALUE.TWO_HUNDRED, minLength: NUMERIC_VALUE.THREE })}
                  />
                  <InputError error={errors.title} max={NUMERIC_VALUE.TWO_HUNDRED} min={NUMERIC_VALUE.THREE} />
                </FormGroup>
                <FormGroup className={errors.description ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
                  <Label
                    for="Description"
                  >
                    Opportunity description
                  </Label>
                  <Input
                    type="textarea"
                    className="medium"
                    name="description"
                    placeholder="Enter opportunity description"
                    onChange={(e) => { e.target.value = e.target.value.trimLeft(); }}
                    maxLength={NUMERIC_VALUE.FIVE_HUNDRED}
                    innerRef={register({ required: true })}
                  />
                  <InputError error={errors.description} max={NUMERIC_VALUE.FIVE_HUNDRED} />
                </FormGroup>
                <FormGroup className={errors.offerUrl ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
                  <Label
                    for="offerUrl"
                  >
                    WildFire reference url
                  </Label>
                  <Input
                    type="text"
                    name="offerUrl"
                    data-label="offerUrl"
                    placeholder="Enter wildfire reference url"
                    onChange={(e) => { handleOfferUrl(e.target.value.trimLeft()); }}
                    innerRef={register({
                      required: false,
                      type: 'text',
                      pattern: { value: regexPattern.WEBSITE, message: validationMessages.INVALID_OFFER_URL_ERROR },
                    })}
                  />
                  <InputError error={errors.offerUrl} max={NUMERIC_VALUE.TWO_HUNDRED} />
                </FormGroup>
                <div className="offer-detail-datepicker-wrapper w-100">
                  <FormGroup className="w-100">
                    <Label
                      for="endDeadline"
                    >
                      Participation request deadline
                    </Label>
                    <DatePicker
                      minDate={new Date()}
                      placeholderText="Request deadline"
                      className="form-control"
                      dateFormat="MMMM dd"
                      autoComplete="off"
                      selected={endDeadline}
                      onChange={(selectedDate) => handleOfferTimeline(selectedDate, 'endDeadline')}
                    />
                    <InputError message={!endDeadline ? 'mandatory' : endDeadlineErrorMsg} error={errors.endDeadline} />
                  </FormGroup>
                </div>
                <FormGroup>
                  <Label
                    for="campaign"
                  >
                    Campaign type
                  </Label>
                  <div className="campaign-type-wrapper">
                    {renderCampaignType()}
                  </div>
                  <InputError error={errors.campaignType} />
                </FormGroup>
                <FormGroup>
                  <Label
                    for="viewType"
                  >
                    View type
                  </Label>
                  <div className="view-type-wrapper">
                    {renderViewType()}
                  </div>
                  <InputError error={errors.viewType} />
                </FormGroup>
                <Row className={`${viewTypeIdx !== 0 ? 'disabled-div' : ''}`}>
                  <Col xs="12" md="9">
                    <FormGroup>
                      <Label
                        for="viewType"
                      >
                        Public gig type
                      </Label>
                      <div className="view-type-wrapper">
                        {renderPublicGigType()}
                      </div>
                      <InputError error={errors.gigType} />
                    </FormGroup>
                  </Col>
                  <Col xs="12" md="3">
                    <div className="check-container">
                      <div className="checkbox-with-text small">
                        <label htmlFor="isPinToTop" className="input-container-green">
                          <input
                            name="isPinToTop"
                            id="isPinToTop"
                            type="checkbox"
                            checked={isPinToTop}
                            onClick={(e) => setIsPinToTop(e.target.checked)}
                          />
                          <span className="checkmark" />
                          <span className="checkbox-text">Pin to Top</span>
                        </label>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" md="6">
                    <FormGroup className={`${errors.basePrice ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}`}>
                      <Label
                        for="price"
                      >
                        Opportunity base price
                      </Label>
                      <Row>
                        <Col xs="12">
                          <Input
                            type="text"
                            name="basePrice"
                            placeholder="Enter base price"
                            innerRef={register({
                              pattern: {
                                value: regexPattern.NUMBER_ONLY_WITH_DECIMAL,
                                message: 'invalid!',
                              },
                            })}
                            onFocus={handleBasePriceValueFieldsFocus}
                          />
                          <em>$</em>
                        </Col>
                        <InputError error={errors.basePrice} />
                      </Row>
                    </FormGroup>
                  </Col>
                  <Col xs="12" md="6" className="pl-0">
                    <FormGroup className={`${errors.basePrice ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}`}>
                      <Label
                        for="basePriceText"
                      >
                        Or enter text
                      </Label>
                      <Row>
                        <Col xs="12">
                          <Input
                            type="text"
                            name="basePriceText"
                            placeholder="Enter opportunity base price"
                            innerRef={register({})}
                            onFocus={handleBasePriceValueFieldsFocus}
                            onChange={(e) => { e.target.value = e.target.value.trimLeft(); }}
                          />
                        </Col>
                        <InputError message="Max length 100 characters." max={NUMERIC_VALUE.MAX_BASE_PRICE_INPUT_LIMIT} error={errors.basePriceText} />
                      </Row>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12">
                    <FormGroup>
                      <Label
                        for="betaPostApprovalType"
                      >
                        Beta Post approval
                      </Label>
                      <div className="checkbox-wrapper">
                        {renderBetaPostApproval()}
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12">
                    <FormGroup className="mb-0">
                      <Label
                        for="artistParticipation"
                      >
                        Artist participation
                      </Label>
                      <div className="checkbox-wrapper">
                        {renderArtistParticipation()}
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
              <h2>Associate brand categories to this opportunity</h2>
              <div className="create-offer-detail-wrapper">
                <FormGroup className={`mb-0 ${errors.categories ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}`}>
                  <Label
                    for="category"
                  >
                    Add category tags
                  </Label>
                  <>
                    <CategoryTagSelect
                      initialData={categoryData}
                      placeholder="Enter Category Data"
                      handleSelectedCategories={handleSelectedCategories}
                      value={form.categories}
                    />
                  </>
                  <InputError error={errors.categories} />
                </FormGroup>
              </div>
              <h2>Target audience</h2>
              <div className="create-offer-detail-wrapper">
                <div className="age-range-select">
                  <Label
                    for="age"
                  >
                    Audience age range
                  </Label>
                  <div className="checkbox-column">
                    {TARGET_AUDIENCE_RANGE.map((item) => (
                      <Label key={item.key} className="input-container-green">
                        <AgeCheckbox
                          name={item.name}
                          checked={checkedItems[item.name]}
                          onChange={handleAgeRangeChange}
                        />
                        <span className="checkmark" />
                        {item.label}
                      </Label>
                    ))}
                  </div>
                  <span className="form-error-text age-error">{isAgeRangeError && validationMessages.REQUIRED}</span>
                </div>
                <div className="age-range-select">
                  <Label
                    for="Audience"
                  >
                    Audience gender
                  </Label>
                  <div className="checkbox-column">
                    <Label for="male" className={`input-container-green ${errors.male ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}`}>
                      <Input
                        name="male"
                        id="male"
                        type="checkbox"
                        checked={isMaleChecked}
                        onClick={setAudienceGenderType}
                      />
                      <span className="checkmark" />
                      Male
                    </Label>
                    <Label for="female" className={` input-container-green ${errors.male ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}`}>
                      <Input
                        name="female"
                        id="female"
                        type="checkbox"
                        checked={isFemaleChecked}
                        onClick={setAudienceGenderType}
                      />
                      <span className="checkmark" />
                      Female
                    </Label>
                  </div>
                  <span className="form-error-text age-error">{isGenderAudienceError && validationMessages.REQUIRED}</span>
                </div>
                <FormGroup className={`mb-0 target-country-wrapper ${errors.country ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}`}>
                  <Label
                    for="country"
                  >
                    Target country
                  </Label>
                  <Country
                    className="multiselect"
                    onChange={handleCountryChange}
                    value={form.country}
                    isMulti
                  />
                  <InputError error={errors.country} />
                </FormGroup>
              </div>
            </div>
            <div className="create-offer-timeline">
              <h2>Campaign timeline</h2>
              <div className="create-offer-timeline-box-wrapper">
                <CampaignTimeLine
                  campaignTimeline={campaignTimeline}
                  errors={errors}
                  register={register}
                  handleRemove={handleRemove}
                  handleChangeTitle={handleChangeTitle}
                  handleChangeHashtag={handleChangeHashtag}
                  handleEditorChange={handleEditorChange}
                  handleFromDate={handleFromDate}
                  handleShareTimeLine={handleShareTimeLine}
                  isOfferPublished={false}
                  isPublishedOfferEditable
                />
              </div>
              <div className="create-offer-timeline-btn-wrapper">
                <span onClick={handleAddAnother}>+ Add another segment</span>
              </div>
            </div>
          </div>
        </div>
      </Form>
      { createContractModal && (
        <CreateContract
          isOpen={createContractModal}
          onClose={() => { toggleCreateContractModal(); }}
          submitContractCallBack={onSubmitContract}
          contractData={contractData}
          isContractEdit={isCreateContractAdded}
        />
      )}
      {isOpenCropModal && (
        <ImageCropper
          width={modalObj.width}
          height={modalObj.height}
          isClientLogo={modalObj.isClientLogo}
          isOpen={isOpenCropModal}
          image={image}
          savedCroppedImage={modalObj.callback}
          onClose={hideFileSelectModal}
        />
      )}
      { inviteArtistModal && (
        <InviteArtistModal
          isOpen={inviteArtistModal}
          onClose={() => { toggleInviteArtistModal(); }}
          publishAndInviteOffer={publishAndInviteOffer}
          categoriesData={form.categories}
          targetAudience={filledOfferObj.targetAudience}
          basePrice={basePriceValue}
          isInviteOnly={false}
          offerId={offerData && offerData._id}
        />
      )}

      { isDeleteOfferModal && (
        <DeleteOffer
          isOpen={isDeleteOfferModal}
          onClose={() => { toggleDeleteOfferModal(); }}
          offerId={offerData && offerData._id}
          deleteOffer={() => { onDeleteOfferCallback(offerData && offerData._id); }}
        />
      )}
      { isPageLeaveModal && (
        <PageLeaveAlert
          isOpen={isPageLeaveModal}
          onClose={() => { setPageLeaveModal(false); }}
        />
      )}
      { isSeeOfferPreviewModal && (
        <SeeOfferPreview
          isOpen={isSeeOfferPreviewModal}
          onClose={() => { setIsSeeOfferPreviewModal(false); }}
          clientLogo={clientLogo}
          coverImage={coverImage}
          isClientLogoHide={isClientLogoHide}
        />
      )}
    </>
  );
}

CreateOffer.propTypes = {
  offerData: PropTypes.shape({
    _id: PropTypes.string,
    isPublish: PropTypes.bool,
    title: PropTypes.string,
    clientName: PropTypes.string,
    campaignType: PropTypes.string,
    viewType: PropTypes.string,
    gigType: PropTypes.string,
    isPinToTop: PropTypes.bool,
    isClientLogoHide: PropTypes.bool,
    isBetaPostApproval: PropTypes.bool,
    isArtistParticipation: PropTypes.bool,
    description: PropTypes.string,
    offerUrl: PropTypes.string,
    clientLogo: PropTypes.string,
    campaignTimeline: PropTypes.arrayOf(PropTypes.shape({
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      description: PropTypes.string,
      shareType: PropTypes.shape({
        facebook: PropTypes.bool,
        instagram: PropTypes.bool,
        twitter: PropTypes.bool,
        youtube: PropTypes.bool,
        spotify: PropTypes.bool,
      }),
    })),
    targetAudience: PropTypes.shape({
      audienceAge: PropTypes.object,
      gender: PropTypes.array,
      country: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      })),
    }),
    createContract: PropTypes.string,
    createdAt: PropTypes.string,
  }),
  submitCallBack: PropTypes.func.isRequired,
  categoryData: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    _id: PropTypes.string,
  })),
  onDeleteOfferCallback: PropTypes.func.isRequired,
  isEditOffer: PropTypes.bool.isRequired,
};

CreateOffer.defaultProps = {
  offerData: null,
  categoryData: null,
};

export default CreateOffer;
